<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menu"
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        slot="activator"
        v-model="dateField"
        :label="label"
        :hint="hint"
        persistent-hint
        append-icon="event"
        clearable
        :readonly="readonly"
        :required="required"
        :error-messages="errorMessages"
        @input="checkDateFormat()"
        v-on="on"
        outlined
        dense
        class="filter-fields"
        v-on:click:append="menu = true"
        color="#273896"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      :max="stringMaxDate"
      :min="stringMinDate"
      @input="menu = false"
      @change="changeFormat()"
      color="#273896"
    ></v-date-picker>
  </v-menu>
</template>

<style>
.v-input.align-icons .v-input__append-inner {
  margin-top: 13px !important;
}
</style>

<script>
import DatePicker from "./datePicker.ts";
export default DatePicker;
</script>
